'use client';

import { config } from '@/helpers';
import { Text } from '@weareconceptstudio/core';

//* Components
import Button from '@/components/Button';

//* Style
import Custom404TemplateStyle from './style';

const Custom404Template = () => {
	return (
		<Custom404TemplateStyle>
			<div className={'wrapper-content-inner'}>
				<Text
					tag={'h1'}
					className={'h3 font-montserrat-arm-medium'}
					text={'errTitle'}
				/>

				<Text
					className={'p p2 err-desc'}
					text={'errDesc'}
				/>

				<Button
					className={'btn'}
					text={'errBtnText'}
					url={config.routes.home.path}
				/>
			</div>
		</Custom404TemplateStyle>
	);
};

export default Custom404Template;
